<template>
  <Layout>
    <div class="row">
      <div class="col-12">
              <div class="row">
                <div class="col-md-4">
                  <div class="card">
                  <div class="card-body p-2">
                    <div class=" mb-2 d-flex justify-content-between">
                      <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      <!-- <img class="img-rounded" src="@/assets/images/sick.png" height="60px" /> -->
                      <span><router-link :to="{ path: '/printinvoice',  query: { id: this.$route.query.id }}" type="button" class="btn-sm btn btn-info"> <i class="mdi mdi-printer"></i> print</router-link></span>
                    </div>
                    <span v-if="patientspinner==false">
                    <div v-for="item in patients" :key="item.id" class="table">
                      <!-- <img class="img-rounded" :src="getPhotos(item.photo)" height="50px" /> -->
                    <h6><span> Full Name: </span><b>{{ item.name }} </b></h6>
                    <h6><span> Gender: </span><b>{{ item.gender }} </b></h6>
                    <h6><span> Telephone: </span><b>0{{ item.telephone }} </b></h6>
                    <h6><span> Date of Birth: </span><b>{{ item.date_of_birth }} </b></h6>
                    <h6><span> Email Address: </span><b>{{ item.email }} </b></h6>
                    <h6><span> Address: </span><b> {{ item.address }} </b></h6>
                    <h6><span> NIN / Passport No: </span><b> {{ item.nin }} </b></h6>
                    </div>
                    </span>
                    <span v-else class="d-flex justify-content-center">
                      <b-spinner type="grow" class="p-4 m-5 text-primary"></b-spinner>
                    </span>
                  </div>
                  </div>
                </div>
                <div class="col-md-8" style="font-family:Arial, Helvetica, sans-serif;">
                  <!-- <div v-if="userData.settings.print_trans == '1'" > -->
                    <div v-if="userData && userData.settings && userData.settings.print_trans == '1'">
                  <span v-if="services.length">
                  <h5>Services</h5>
                    <table class="table table-sm mt-2" style="color: black;" density="compact">
                    <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th></tr></thead>
                    <tbody>
                      <tr v-for="item in services" :key="item.id">
                          <td>{{ item.service_category.name }} </td>
                          <td>{{ item.service_name.name }}</td>
                          <td>{{ item.service_price }}</td>
                      </tr>
                    </tbody>
                    </table>
                  </span>
                  <span v-if="prescriptions.length">
                    <h5>Presciptions</h5>
                      <table class="table table-sm" style="color: black;" density="compact">
                      <thead><tr><th>Medicine</th><th>Quantity</th><th>Price</th></tr></thead>
                      <tbody>
                          <tr v-for="item in prescriptions" :key="item.id">
                          <td>{{ item.medicine.name }} </td>
                          <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                          <td>{{ item.totalprice }}</td>
                          </tr>
                      </tbody>
                      </table>
                  </span>
                  <span v-if="consumables.length">
                  <h5>Consumables</h5>
                    <table class="table table-sm table-bordered" style="color: black;" density="compact">
                    <thead><tr><th>Consumable</th><th>Quantity</th><th>Price</th></tr></thead>
                    <tbody>
                        <tr v-for="item in consumables" :key="item.id">
                        <td>{{ item.consumbale.name }} </td>
                        <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                        <td>{{ item.totalprice }}</td>
                        </tr>
                    </tbody>
                    </table>
                  </span>
                  <span v-if="payments.length">
                    <h5>Payments</h5>
                      <table class="table table-sm mt-2" style="color: black;" density="compact">
                      <thead><tr><th>Pay Date</th><th>Amount Paid</th><th>Discount</th><th>Payment Type</th></tr></thead>
                      <tbody>
                        <tr v-for="item in payments" :key="item.id">
                            <td>{{ item.pay_date }}</td>
                            <td>{{ commas(item.amount_paid) }}</td>
                            <td>{{ commas(item.amount_discount) }}</td>
                            <td>
                              <span v-if="item.payment_type==1">Cash</span>
                              <span v-else>Account</span>
                            </td>
                        </tr>
                      </tbody>
                      </table>
                  </span>
                </div>
                <div v-else>
        <span v-if="services.length">
    <h5 >Services</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
        <thead><tr><th>Category</th><th>Service Name</th></tr></thead>
   
      <tbody>
        <tr v-for="item in services" :key="item.id">
                          <td>{{ item.service_category.name }} </td>
                          <td>{{ item.service_name.name }}</td>
                         
        </tr>
        <!-- <tr>
          <b>    <td> Sub Total: {{ totalServicePrice }}</td></b>
        </tr> -->
      </tbody>
      </table>
      </span>
      <span v-if="prescriptions.length">
          <h5 >Presciptions</h5>
            <table class="table table-sm mt-n2" style="color: black;" density="compact">
              <thead><tr><th>Medicine</th><th>Quantity</th></tr></thead>

            <tbody>
              <tr v-for="item in prescriptions" :key="item.id">
                          <td>{{ item.medicine.name }} </td>
                          <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
              </tr>
                <!-- <tr >
                   <b><td> Sub Total: {{ totalPresciptionsPrice }}</td></b>
                </tr> -->
            </tbody>
            </table>
        </span>
        <span v-if="consumables.length">
        <h5 >Consumables</h5>
          <table class="table table-sm mt-n2" style="color: black;" density="compact">
            <thead><tr><th>Consumable</th><th>Quantity</th></tr></thead>

          <tbody>
            <tr v-for="item in consumables" :key="item.id">
                        <td>{{ item.consumbale.name }} </td>
                        <td>{{ item.quantity }} {{ item.unit.unit_name }}</td>
                      
            </tr>
              <!-- <tr >             
                 <b><td> Sub Total: {{ totalComsumablePrice }}</td></b>
              </tr> -->
          </tbody>
          </table>
        </span>
        <h5 >Total Amount</h5>
        <table class="table table-sm mt-n2" style="color: black;" density="compact">
          <tr>
            <td> <b>   {{ commas (totalAmountPrice) }} </b></td>
          </tr>
        </table>
      <span v-if="payments.length">
    <h5 >Payments</h5>
      <table class="table table-sm mt-n2" style="color: black;" density="compact">
      <thead><tr><th>Pay Date</th><th>Amount Paid Time</th><th>Discount</th><th>Payment Type</th></tr></thead>
      <tbody>
        <tr v-for="item in payments" :key="item.id">
            <td>{{ item.pay_date }}</td>
            <td>{{ commas(item.amount_paid) }}</td>
            <td>{{ commas(item.amount_discount) }}</td>
            <td>
              <span v-if="item.payment_type==1">Cash</span>
              <span v-else>Account</span>
            </td>
        </tr>
      </tbody>
      </table>
      </span>
    </div>
                  <div class="d-flex justify-content-between">
                    <span class="h5 text-black"> Total Amount Paid: <span class="text-primary h2">{{ commas(amount_paid) }}</span></span>
                    <span class="h5 text-black"> Total Discount: <span class="text-primary h2">{{ commas(amount_discount) }}</span></span>
                    <span class="h5 text-black me-5"> Pending Balance: <span class="text-primary h2">{{ commas(balance) }}</span></span>
                  </div>

                

              </div>
              </div>
              
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Patient Treatment",
    meta: [{name: "description",content: appConfig.description,},],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "Payment Legder",
      items: [{text: "Dashboard",to: "/",},{text: "Payment Legder",active: true,},],
      userData: JSON.parse(localStorage.getItem("user")),
      patients:[],
      payments:[],
      services:[],
      patientspinner:true,
      patientid:'',
      visitid:'',
      consumables:[],
      prescriptions:[],
      amount_paid:0,
      amount_discount:0,
      balance:0,
    };
  },
  created() {
    this.fetchInfo();
  },
//   computed: {
//   totalServicePrice() {
    
//     return this.services.reduce((total, service) => total + (Number(service.service_price, 0)));
//   },
//   totalPresciptionsPrice() {
    
//     return this.prescriptions.reduce((total, prescription) => total + prescription.totalprice, 0);
//   },
//   totalComsumablePrice() {
  
//     return this.consumables.reduce((total, consumable) => total + consumable.totalprice, 0);
//   },
//   totalAmountPrice(){
//     return this.totalComsumablePrice + this.totalPresciptionsPrice + this.totalServicePrice
//   },
// },
computed: {
  totalServicePrice() {
    return this.services.reduce((total, service) => total + Number(service.service_price || 0), 0);
  },
  totalPresciptionsPrice() {
    return this.prescriptions.reduce((total, prescription) => total + Number(prescription.totalprice || 0), 0);
  },
  totalComsumablePrice() {
    return this.consumables.reduce((total, consumable) => total + Number(consumable.totalprice || 0), 0);
  },
  totalAmountPrice() {
    return this.totalComsumablePrice + this.totalPresciptionsPrice + this.totalServicePrice;
  }
},
  methods: {
    commas(x) { return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

    async fetchInfo(){
      this.id=this.$route.query.id;
      let url = `/legderinfo/${this.id}`;
      await axios.get(url).then((response) => {
        this.patientid = response.data.visits[0].patient.patient_id;
        this.visitid = response.data.visits[0].visit_id;
        this.showpatient();
        
      });
    },
    getPhotos(name){
            let url = axios.defaults.baseURL;
            let imagelink = (url).slice(0,-3)+"patients/"+name;
            return imagelink;
          },
    async showpatient(){
      let url = `/patientprofile/${this.patientid}`;
      await axios.get(url).then((response) => {
        this.patients = response.data.patients;
        this.patientspinner=false;
        this.showpayments();
        this.showservices();
        this.showtprescriptions();
        this.showtconsumables();
        this.showbalances();
      });
    },
    async showservices(){
      let url = `/profileservices/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.services = response.data.visits;
      });
    },
    async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtconsumables(){
        let url = `/profileconsumables/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consumables = response.data.consumables;
        });
      },
    async showpayments(){
      let url = `/legdgerpayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.payments = response.data.payments;
      });
    },
    async showbalances(){
      let url = `/invoicepayments/${this.patientid},${this.visitid}`;
      await axios.get(url).then((response) => {
        this.amount_paid = response.data.payments[0].paid;
        this.balance = response.data.payments[0].balance;
        this.amount_discount = response.data.payments[0].discount;
      });
    },
  },
};
</script>